
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import {voice} from './voice';

export default new Vuex.Store({
  modules: {
    voice,
  },
});